import GpsType from '@/api/master/GpsType'
import Functions from '@/functions'

export default {
  namespaced: true,
  state: {
    total: 0,
    data: [],
    select: [],
  },
  mutations: {
    SET_DATA(state, data) {
      state.data = data.data
      state.total = data.total
    },
    SET_SELECT_OPTIONS(state, data) {
      state.select = data
    }
  },
  actions: {
    datatable({commit}, params) {
      return GpsType.datatable(params).then(res => {
        commit('SET_DATA', res.data.message)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    detail({}, id) {
      return GpsType.detail(id).then(res => {
        const {data} = res.data.message
        return data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    select({commit}) {
      return GpsType.select().then(res => {
        commit('SET_SELECT_OPTIONS', res.data.message.data)
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    store({}, data) {
      return GpsType.store(data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    update({}, {id, ...data}) {
      return GpsType.update(id, data).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    },
    delete({}, id) {
      return GpsType.delete(id).then(res => {
        return res.data
      }).catch(error => {
        Functions.httpErrorHandler(error)
        return { status: false, message: null }
      })
    }
  },
  getters: {}
}
